import { useTranslation } from 'react-i18next';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { ROUTES } from 'features/routes';
import { IdParamsType } from 'utils/types';
import { getCustomFieldName } from 'utils/utils';
import { CustomField as CustomFieldType } from 'features/CustomFields/types';

import { CardDescription, CardTitle, CustomFieldCard } from './CustomField.styles';

interface CustomFieldProps extends CustomFieldType {
	/** When provided, clicking the card calls this instead of navigating. */
	onEdit?: (id: number) => void;
}

export const CustomField = ({ name, only_buyer, is_required, ticket_types, ID, onEdit }: CustomFieldProps) => {
	const { t } = useTranslation();
	const { push } = useHistory();
	const { id: eventId } = useParams<IdParamsType>();
	const onClick = (id: number) => {
		if (onEdit) {
			onEdit(id);
		} else {
			push(generatePath(ROUTES.DASHBOARD_EDIT_CUSTOM_FIELDS, { id, eventId }));
		}
	};

	return (
		<CustomFieldCard onClick={() => onClick(ID)}>
			<CardTitle>{getCustomFieldName(name)}</CardTitle>
			<CardDescription>{only_buyer ? t('customFields-buyerOnly') : t('customFields-eachAttendee')}</CardDescription>
			<CardDescription>{ticket_types?.map(({ name }) => name).join(', ')}</CardDescription>
			<CardDescription>{is_required ? t('customFields-required') : t('customFields-notRequired')}</CardDescription>
		</CustomFieldCard>
	);
};
